import { render, staticRenderFns } from "./LemmaSelect.vue?vue&type=template&id=693c3f59&"
import script from "./LemmaSelect.vue?vue&type=script&lang=js&"
export * from "./LemmaSelect.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports